import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import Notify, { AlertTypes } from 'Services/notification';
import i18n from 'Services/i18n';
import EventService from 'Services/events';
import { routeStateSelector, searchSelector } from 'Store/modules/router/selectors';
import useSegment from 'Hooks/useSegment';
import useHotjar from 'Hooks/useHotjar';
import { FRONT_PLANS } from 'Constants/plans';

const RouteListener = ({ history }) => {
  const { pathname } = history.location;
  const planes = useSelector(searchSelector);
  const state = useSelector(routeStateSelector);
  const saveCardParams = useSelector(searchSelector);
  const paymentMethod = useSelector(searchSelector);
  const { plans } = queryString.parse(planes);
  const { saveCard } = queryString.parse(saveCardParams);
  const { method } = queryString.parse(paymentMethod);
  useEffect(() => {
    if (plans) {
      if (plans !== FRONT_PLANS.FLEX && plans !== FRONT_PLANS.FLEX_LITE) {
        Notify.sendNotification(i18n.t('plans:Plans.checkout.success'), AlertTypes.success);
      }
      EventService.orderCompleted(plans.toString(), method);
    }
    if (saveCard) {
      Notify.sendNotification(i18n.t('common:SaveCard.success'), AlertTypes.success);
      EventService.saveCardSessionCompleted();
    }
  }, [plans]);
  useSegment(pathname, state);
  useHotjar(pathname);
  return null;
};

RouteListener.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(RouteListener);
